export default __webpack_public_path__ + "static/mi-bg-2ed459e2f293ef2e2807ee9715a822d1.png";